import { useContext } from 'react'
import { Outlet, useParams } from 'react-router-dom'
import { DisplayContext } from '../../../../../../../components/gatekeeper'
import { PaymentsWorkflow } from '../../../../../../../components/workflow-containers/payments'
import { ErrorCode } from '../../../../../../../constants'
import { RouteParams } from '../../../../../../../types/route'

export const Payments = () => {
  const { id } = useParams<RouteParams>()
  const { setError } = useContext(DisplayContext)
  if (!id) {
    setError(ErrorCode.NOT_FOUND_404)
    return null
  }
  return (
    <PaymentsWorkflow recordId={id}>
      <Outlet />
    </PaymentsWorkflow>
  )
}
